import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditCostProfileRequestFailure({ uuid }) {
      const req = getState().find(
        ({ costProfile }) => costProfile.uuid === uuid,
      );

      return req ? req.request.isFailure : false;
    },
    isEditCostProfileRequestPending({ uuid }) {
      const req = getState().find(
        ({ costProfile }) => costProfile.uuid === uuid,
      );

      return req ? req.request.isPending : false;
    },
    isEditCostProfileRequestSuccess({ uuid }) {
      const req = getState().find(
        ({ costProfile }) => costProfile.uuid === uuid,
      );

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
